<article class="rounded-[1.35rem] border border-black/[0.06] bg-[#fcfaf7] p-4 shadow-sm">
  <div class="flex items-start justify-between gap-3">
    <div class="min-w-0">
      <h3 class="truncate text-sm font-black uppercase tracking-tight text-[#1f1b16]">
        {{ item().description }}
      </h3>

      <p class="mt-1 text-xs font-medium text-[#3a332c]/55">
        {{ item().quantity }} unidad{{ item().quantity === 1 ? '' : 'es' }}
      </p>
    </div>

    <span
      class="shrink-0 rounded-full bg-orange-100 px-3 py-1 text-[11px] font-bold text-orange-700"
    >
      Enviado
    </span>
  </div>

  <div class="mt-3 rounded-2xl bg-[#f6f1eb] px-3 py-2">
    <p class="text-[12px] font-semibold text-[#1f1b16]">
      {{ label() }}
    </p>

    @if (groupsLabel()) {
      <p class="mt-1 text-[11px] leading-relaxed text-[#3a332c]/65">
        {{ groupsLabel() }}
      </p>
    }
  </div>
</article>
